import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelDynamic as _vModelDynamic, vModelSelect as _vModelSelect, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_3 = { class: "dash-stats-row" }
const _hoisted_4 = { class: "dash-stat-card" }
const _hoisted_5 = { class: "dash-stat-value" }
const _hoisted_6 = { class: "dash-stat-card" }
const _hoisted_7 = { class: "dash-stat-value" }
const _hoisted_8 = { class: "dash-stat-card" }
const _hoisted_9 = { class: "dash-stat-value" }
const _hoisted_10 = { class: "dash-stat-card" }
const _hoisted_11 = { class: "dash-stat-value" }
const _hoisted_12 = {
  key: 0,
  class: "dash-stat-card"
}
const _hoisted_13 = { class: "dash-stat-value" }
const _hoisted_14 = { class: "row g-4" }
const _hoisted_15 = { class: "col-lg-7" }
const _hoisted_16 = { class: "dash-card h-100" }
const _hoisted_17 = { class: "dash-card-header" }
const _hoisted_18 = { class: "dash-table-wrap" }
const _hoisted_19 = { class: "dash-table" }
const _hoisted_20 = { class: "dash-user-cell" }
const _hoisted_21 = { class: "dash-mini-avatar" }
const _hoisted_22 = { class: "text-silver" }
const _hoisted_23 = { class: "text-silver" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "col-lg-5" }
const _hoisted_26 = { class: "dash-card h-100" }
const _hoisted_27 = { class: "dash-card-header" }
const _hoisted_28 = {
  key: 0,
  class: "dash-badge badge-orange"
}
const _hoisted_29 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "dash-mini-avatar" }
const _hoisted_32 = { style: {"flex":"1","min-width":"0"} }
const _hoisted_33 = { style: {"color":"#fff","font-size":"0.9rem","font-weight":"600","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_34 = {
  class: "text-silver",
  style: {"font-size":"0.78rem"}
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "dash-page-header" }
const _hoisted_38 = { class: "d-flex gap-2 align-items-center flex-wrap" }
const _hoisted_39 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_40 = {
  key: 1,
  class: "dash-card"
}
const _hoisted_41 = { class: "dash-table-wrap" }
const _hoisted_42 = { class: "dash-table" }
const _hoisted_43 = { class: "dash-user-cell" }
const _hoisted_44 = { class: "dash-mini-avatar" }
const _hoisted_45 = { class: "text-silver" }
const _hoisted_46 = { class: "text-silver" }
const _hoisted_47 = {
  key: 1,
  class: "dash-badge badge-gray"
}
const _hoisted_48 = {
  key: 1,
  class: "dash-badge badge-gray"
}
const _hoisted_49 = {
  class: "text-silver",
  style: {"font-size":"0.82rem"}
}
const _hoisted_50 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_56 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_57 = { class: "d-flex gap-2" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { class: "dash-page-header" }
const _hoisted_62 = {
  key: 0,
  class: "dash-card mb-4"
}
const _hoisted_63 = { class: "dash-card-header" }
const _hoisted_64 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_65 = {
  key: 1,
  class: "dash-alert dash-alert-success mb-3"
}
const _hoisted_66 = {
  class: "dash-field-group mb-3",
  style: {"position":"relative"}
}
const _hoisted_67 = { class: "compose-to-row" }
const _hoisted_68 = {
  key: 0,
  class: "compose-resolved"
}
const _hoisted_69 = {
  key: 1,
  class: "compose-dropdown"
}
const _hoisted_70 = ["onMousedown"]
const _hoisted_71 = {
  class: "dash-mini-avatar",
  style: {"width":"28px","height":"28px","font-size":"0.75rem","flex-shrink":"0"}
}
const _hoisted_72 = { style: {"flex":"1","min-width":"0"} }
const _hoisted_73 = { style: {"color":"#fff","font-size":"0.88rem","font-weight":"600"} }
const _hoisted_74 = { style: {"color":"#888","font-size":"0.78rem"} }
const _hoisted_75 = {
  key: 0,
  class: "compose-dropdown-item",
  style: {"color":"#888","font-size":"0.82rem"}
}
const _hoisted_76 = { class: "dash-field-group mb-3" }
const _hoisted_77 = { class: "dash-field-group mb-4" }
const _hoisted_78 = { class: "d-flex gap-2" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "border-style" }
const _hoisted_81 = {
  class: "dash-page-header",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_82 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_83 = {
  key: 1,
  class: "dash-loading"
}
const _hoisted_84 = {
  key: 2,
  class: "dash-card text-center py-5"
}
const _hoisted_85 = {
  key: 3,
  class: "dash-card"
}
const _hoisted_86 = { class: "dash-table-wrap" }
const _hoisted_87 = { class: "dash-table" }
const _hoisted_88 = { class: "dash-user-cell" }
const _hoisted_89 = { class: "dash-mini-avatar" }
const _hoisted_90 = { style: {"color":"#fff","font-size":"0.88rem"} }
const _hoisted_91 = {
  class: "text-silver",
  style: {"font-size":"0.78rem"}
}
const _hoisted_92 = { style: {"color":"#fff","max-width":"240px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_93 = {
  class: "text-silver",
  style: {"font-size":"0.82rem","white-space":"nowrap"}
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_96 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_97 = { class: "d-flex gap-2" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { key: 3 }
const _hoisted_101 = {
  class: "dash-stats-row",
  style: {"margin-bottom":"1.5rem"}
}
const _hoisted_102 = { class: "dash-stat-card" }
const _hoisted_103 = { class: "dash-stat-value" }
const _hoisted_104 = { class: "dash-stat-card" }
const _hoisted_105 = { class: "dash-stat-value" }
const _hoisted_106 = { class: "dash-stat-card" }
const _hoisted_107 = { class: "dash-stat-value" }
const _hoisted_108 = { class: "dash-stat-card" }
const _hoisted_109 = { class: "dash-stat-value" }
const _hoisted_110 = {
  class: "dash-page-header",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_111 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_112 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_113 = {
  key: 1,
  class: "dash-card"
}
const _hoisted_114 = { class: "dash-table-wrap" }
const _hoisted_115 = { class: "dash-table" }
const _hoisted_116 = { class: "dash-user-cell" }
const _hoisted_117 = { class: "dash-mini-avatar" }
const _hoisted_118 = {
  class: "text-silver",
  style: {"font-size":"0.75rem"}
}
const _hoisted_119 = {
  class: "text-silver",
  style: {"white-space":"nowrap"}
}
const _hoisted_120 = { style: {"font-size":"0.75rem"} }
const _hoisted_121 = { style: {"color":"#4ade80","font-weight":"700"} }
const _hoisted_122 = {
  class: "text-silver",
  style: {"font-size":"0.78rem","max-width":"140px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_123 = {
  class: "text-silver",
  style: {"font-size":"0.82rem","white-space":"nowrap"}
}
const _hoisted_124 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = ["disabled", "onClick"]
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_129 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_130 = { class: "d-flex gap-2" }
const _hoisted_131 = ["disabled"]
const _hoisted_132 = ["disabled"]
const _hoisted_133 = { key: 4 }
const _hoisted_134 = { class: "dash-page-header" }
const _hoisted_135 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_136 = {
  key: 1,
  class: "dash-card"
}
const _hoisted_137 = { class: "dash-table-wrap" }
const _hoisted_138 = { class: "dash-table" }
const _hoisted_139 = { style: {"width":"64px","padding":"0.4rem 0.75rem"} }
const _hoisted_140 = { class: "pkg-thumb-wrap" }
const _hoisted_141 = ["src", "alt"]
const _hoisted_142 = {
  key: 1,
  class: "pkg-thumb-empty"
}
const _hoisted_143 = { style: {"color":"#fff","font-weight":"600"} }
const _hoisted_144 = { style: {"color":"#c90e0e","font-weight":"700"} }
const _hoisted_145 = { class: "text-silver" }
const _hoisted_146 = ["title"]
const _hoisted_147 = {
  key: 1,
  class: "dash-badge badge-gray",
  title: "No panel mapping — lines must be assigned manually"
}
const _hoisted_148 = {
  class: "text-silver",
  style: {"font-size":"0.82rem","max-width":"200px"}
}
const _hoisted_149 = { key: 0 }
const _hoisted_150 = { key: 1 }
const _hoisted_151 = { class: "d-flex gap-2" }
const _hoisted_152 = ["onClick"]
const _hoisted_153 = ["onClick"]
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { key: 5 }
const _hoisted_156 = { class: "dash-page-header" }
const _hoisted_157 = {
  key: 0,
  class: "dash-card mb-4",
  style: {"border-left":"3px solid #fbbf24"}
}
const _hoisted_158 = {
  key: 1,
  class: "dash-stats-row",
  style: {"margin-bottom":"1.5rem"}
}
const _hoisted_159 = { class: "dash-stat-card" }
const _hoisted_160 = { class: "dash-stat-value" }
const _hoisted_161 = { class: "dash-stat-card" }
const _hoisted_162 = {
  class: "dash-stat-value",
  style: {"font-size":"1.1rem"}
}
const _hoisted_163 = { class: "dash-stat-card" }
const _hoisted_164 = {
  class: "dash-stat-value",
  style: {"font-size":"1.1rem"}
}
const _hoisted_165 = { class: "dash-card mb-4" }
const _hoisted_166 = { class: "dash-card-header" }
const _hoisted_167 = { class: "d-flex gap-2" }
const _hoisted_168 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_169 = {
  key: 1,
  class: "dash-table-wrap"
}
const _hoisted_170 = { class: "dash-table" }
const _hoisted_171 = { class: "dash-user-cell" }
const _hoisted_172 = { class: "dash-mini-avatar" }
const _hoisted_173 = { style: {"color":"#fff","font-size":"0.88rem"} }
const _hoisted_174 = {
  class: "text-silver",
  style: {"font-size":"0.75rem"}
}
const _hoisted_175 = {
  key: 0,
  class: "dash-badge",
  style: {"background":"rgba(168,85,247,0.15)","color":"#a855f7","text-transform":"uppercase"}
}
const _hoisted_176 = {
  key: 1,
  class: "dash-badge badge-gray"
}
const _hoisted_177 = {
  class: "text-silver",
  style: {"font-size":"0.82rem","max-width":"200px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_178 = {
  class: "text-silver",
  style: {"font-size":"0.82rem","white-space":"nowrap"}
}
const _hoisted_179 = ["onClick"]
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_182 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_183 = { class: "d-flex gap-2" }
const _hoisted_184 = ["disabled"]
const _hoisted_185 = ["disabled"]
const _hoisted_186 = { class: "dash-card" }
const _hoisted_187 = { class: "dash-card-header" }
const _hoisted_188 = {
  key: 0,
  class: "text-silver py-3",
  style: {"font-size":"0.9rem"}
}
const _hoisted_189 = {
  key: 1,
  class: "dash-table-wrap"
}
const _hoisted_190 = { class: "dash-table" }
const _hoisted_191 = { style: {"color":"#a855f7","font-weight":"700"} }
const _hoisted_192 = { style: {"color":"#fff","font-weight":"600"} }
const _hoisted_193 = { class: "text-silver" }
const _hoisted_194 = { class: "text-silver" }
const _hoisted_195 = { class: "text-silver" }
const _hoisted_196 = {
  key: 0,
  class: "dash-badge badge-green"
}
const _hoisted_197 = {
  key: 1,
  class: "dash-badge badge-gray"
}
const _hoisted_198 = { key: 6 }
const _hoisted_199 = { class: "dash-page-header" }
const _hoisted_200 = { class: "d-flex gap-2 flex-wrap mb-3" }
const _hoisted_201 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_202 = {
  key: 1,
  class: "dash-card"
}
const _hoisted_203 = { class: "dash-table-wrap" }
const _hoisted_204 = { class: "dash-table" }
const _hoisted_205 = { style: {"width":"64px","padding":"0.4rem 0.75rem"} }
const _hoisted_206 = { class: "pkg-thumb-wrap" }
const _hoisted_207 = ["src", "alt"]
const _hoisted_208 = {
  key: 1,
  class: "pkg-thumb-empty"
}
const _hoisted_209 = { style: {"color":"#fff","font-weight":"600"} }
const _hoisted_210 = {
  class: "dash-badge badge-orange",
  style: {"text-transform":"none"}
}
const _hoisted_211 = { class: "text-silver" }
const _hoisted_212 = { class: "d-flex gap-2" }
const _hoisted_213 = ["onClick"]
const _hoisted_214 = ["onClick"]
const _hoisted_215 = { key: 0 }
const _hoisted_216 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_217 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_218 = { class: "d-flex gap-2" }
const _hoisted_219 = ["disabled"]
const _hoisted_220 = ["disabled"]
const _hoisted_221 = { key: 7 }
const _hoisted_222 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_223 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_224 = {
  class: "dash-card h-100 d-flex flex-column justify-content-between",
  style: {"padding":"1.25rem"}
}
const _hoisted_225 = { class: "d-flex align-items-center gap-2 mb-1" }
const _hoisted_226 = {
  class: "text-white mb-0",
  style: {"font-size":"0.95rem","font-weight":"700"}
}
const _hoisted_227 = {
  class: "text-silver mb-0",
  style: {"font-size":"0.78rem"}
}
const _hoisted_228 = {
  key: 0,
  class: "col-12"
}
const _hoisted_229 = { key: 8 }
const _hoisted_230 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_231 = {
  key: 0,
  class: "dash-alert dash-alert-success mb-4"
}
const _hoisted_232 = {
  key: 1,
  class: "dash-alert dash-alert-danger mb-4"
}
const _hoisted_233 = { class: "dash-card mb-4" }
const _hoisted_234 = { class: "row g-3" }
const _hoisted_235 = { class: "dash-field-label" }
const _hoisted_236 = {
  key: 0,
  class: "st-secret-badge"
}
const _hoisted_237 = ["onUpdate:modelValue", "type", "placeholder"]
const _hoisted_238 = { class: "st-test-row mt-4" }
const _hoisted_239 = { class: "st-test-inputs" }
const _hoisted_240 = ["disabled"]
const _hoisted_241 = {
  key: 0,
  class: "st-test-result st-ok"
}
const _hoisted_242 = {
  key: 1,
  class: "st-test-result st-err"
}
const _hoisted_243 = { class: "dash-card mb-4" }
const _hoisted_244 = { class: "row g-3" }
const _hoisted_245 = { class: "col-md-6" }
const _hoisted_246 = ["value", "disabled"]
const _hoisted_247 = {
  key: 0,
  class: "d-flex gap-2 flex-wrap mt-3"
}
const _hoisted_248 = { class: "dash-card mb-4" }
const _hoisted_249 = { class: "row g-3" }
const _hoisted_250 = { class: "dash-field-label" }
const _hoisted_251 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_252 = { class: "d-flex gap-2" }
const _hoisted_253 = ["disabled"]
const _hoisted_254 = { class: "border-style" }
const _hoisted_255 = { key: 9 }
const _hoisted_256 = { class: "dash-page-header" }
const _hoisted_257 = {
  class: "btn",
  style: {"cursor":"pointer"}
}
const _hoisted_258 = { class: "border-style" }
const _hoisted_259 = ["disabled"]
const _hoisted_260 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_261 = {
  key: 1,
  class: "dash-card text-center py-5"
}
const _hoisted_262 = {
  key: 2,
  class: "media-grid"
}
const _hoisted_263 = { class: "media-thumb" }
const _hoisted_264 = ["src", "alt"]
const _hoisted_265 = { class: "media-info" }
const _hoisted_266 = ["title"]
const _hoisted_267 = { class: "media-actions" }
const _hoisted_268 = ["onClick"]
const _hoisted_269 = ["onClick"]
const _hoisted_270 = {
  class: "dash-modal",
  style: {"max-width":"560px"}
}
const _hoisted_271 = { class: "dash-modal-header" }
const _hoisted_272 = { class: "dash-modal-body" }
const _hoisted_273 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_274 = {
  key: 1,
  class: "dash-mac-info mb-3"
}
const _hoisted_275 = { style: {"color":"#c90e0e","font-size":"0.95rem"} }
const _hoisted_276 = {
  key: 2,
  class: "dash-mac-info dash-mac-missing mb-3"
}
const _hoisted_277 = {
  key: 3,
  class: "dash-mac-info mb-3"
}
const _hoisted_278 = { style: {"color":"#a0a0a0","font-size":"0.75rem","margin-bottom":"2px"} }
const _hoisted_279 = { style: {"color":"#a855f7","text-transform":"uppercase"} }
const _hoisted_280 = { key: 0 }
const _hoisted_281 = {
  key: 0,
  style: {"color":"#c90e0e","font-size":"0.85rem"}
}
const _hoisted_282 = { class: "row g-3" }
const _hoisted_283 = { class: "col-12" }
const _hoisted_284 = { class: "col-12" }
const _hoisted_285 = { class: "col-12" }
const _hoisted_286 = { class: "col-6" }
const _hoisted_287 = { class: "col-6" }
const _hoisted_288 = { class: "col-12" }
const _hoisted_289 = {
  class: "dash-modal-footer",
  style: {"flex-wrap":"wrap","gap":"0.75rem"}
}
const _hoisted_290 = ["disabled"]
const _hoisted_291 = { class: "border-style" }
const _hoisted_292 = ["disabled"]
const _hoisted_293 = ["disabled"]
const _hoisted_294 = ["disabled"]
const _hoisted_295 = {
  key: 3,
  class: "w-100",
  style: {"font-size":"0.82rem","color":"#4ade80","margin-top":"0.25rem"}
}
const _hoisted_296 = {
  key: 4,
  class: "w-100",
  style: {"font-size":"0.82rem","color":"#4ade80","margin-top":"0.25rem"}
}
const _hoisted_297 = { class: "dash-modal" }
const _hoisted_298 = { class: "dash-modal-header" }
const _hoisted_299 = {
  class: "dash-modal-body text-center",
  style: {"padding":"2rem"}
}
const _hoisted_300 = ["href"]
const _hoisted_301 = { class: "dash-modal" }
const _hoisted_302 = { class: "dash-modal-header" }
const _hoisted_303 = { class: "dash-modal-body" }
const _hoisted_304 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_305 = { class: "row g-3" }
const _hoisted_306 = { class: "col-md-6" }
const _hoisted_307 = { class: "col-md-3" }
const _hoisted_308 = { class: "col-md-3" }
const _hoisted_309 = { class: "col-12" }
const _hoisted_310 = { class: "pkg-image-row" }
const _hoisted_311 = {
  key: 0,
  class: "pkg-image-preview"
}
const _hoisted_312 = ["src"]
const _hoisted_313 = { class: "pkg-image-upload" }
const _hoisted_314 = {
  class: "dash-action-btn",
  style: {"cursor":"pointer","white-space":"nowrap"}
}
const _hoisted_315 = ["disabled"]
const _hoisted_316 = { class: "col-md-6" }
const _hoisted_317 = ["value"]
const _hoisted_318 = { class: "col-md-6" }
const _hoisted_319 = ["value"]
const _hoisted_320 = { class: "col-12" }
const _hoisted_321 = { class: "dash-modal-footer" }
const _hoisted_322 = ["disabled"]
const _hoisted_323 = { class: "border-style" }
const _hoisted_324 = {
  class: "dash-modal",
  style: {"max-width":"500px"}
}
const _hoisted_325 = { class: "dash-modal-header" }
const _hoisted_326 = { class: "dash-modal-body" }
const _hoisted_327 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_328 = {
  key: 1,
  class: "dash-alert dash-alert-success mb-3"
}
const _hoisted_329 = {
  class: "dash-field-group mb-3",
  style: {"position":"relative"}
}
const _hoisted_330 = { style: {"position":"relative"} }
const _hoisted_331 = {
  key: 0,
  class: "compose-resolved"
}
const _hoisted_332 = {
  key: 1,
  class: "compose-dropdown"
}
const _hoisted_333 = ["onMousedown"]
const _hoisted_334 = {
  class: "dash-mini-avatar",
  style: {"width":"28px","height":"28px","font-size":"0.75rem","flex-shrink":"0"}
}
const _hoisted_335 = { style: {"color":"#fff","font-size":"0.88rem","font-weight":"600"} }
const _hoisted_336 = { style: {"color":"#888","font-size":"0.78rem"} }
const _hoisted_337 = { class: "dash-field-group mb-3" }
const _hoisted_338 = ["value"]
const _hoisted_339 = { class: "dash-field-group mb-3" }
const _hoisted_340 = { class: "dash-field-group" }
const _hoisted_341 = { class: "dash-modal-footer" }
const _hoisted_342 = ["disabled"]
const _hoisted_343 = { class: "border-style" }
const _hoisted_344 = ["disabled"]
const _hoisted_345 = {
  class: "dash-modal",
  style: {"max-width":"520px"}
}
const _hoisted_346 = { class: "dash-modal-header" }
const _hoisted_347 = { class: "dash-modal-body" }
const _hoisted_348 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_349 = {
  key: 1,
  class: "dash-alert dash-alert-success mb-3"
}
const _hoisted_350 = { class: "dash-field-group mb-3" }
const _hoisted_351 = ["value"]
const _hoisted_352 = { class: "dash-field-group mb-3" }
const _hoisted_353 = { class: "dash-field-group" }
const _hoisted_354 = { class: "dash-modal-footer" }
const _hoisted_355 = ["disabled"]
const _hoisted_356 = { class: "border-style" }
const _hoisted_357 = { class: "dash-modal" }
const _hoisted_358 = { class: "dash-modal-header" }
const _hoisted_359 = { class: "dash-modal-body" }
const _hoisted_360 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_361 = { class: "row g-3" }
const _hoisted_362 = { class: "col-md-8" }
const _hoisted_363 = { class: "col-md-4" }
const _hoisted_364 = { class: "col-md-6" }
const _hoisted_365 = { class: "col-md-3" }
const _hoisted_366 = { class: "col-md-3 d-flex align-items-end" }
const _hoisted_367 = {
  class: "dash-input d-flex align-items-center gap-2",
  style: {"cursor":"pointer","padding":"0.6rem 1rem"}
}
const _hoisted_368 = { class: "col-12" }
const _hoisted_369 = { class: "pkg-image-row" }
const _hoisted_370 = {
  key: 0,
  class: "pkg-image-preview"
}
const _hoisted_371 = ["src"]
const _hoisted_372 = { class: "pkg-image-upload" }
const _hoisted_373 = {
  class: "dash-action-btn",
  style: {"cursor":"pointer","white-space":"nowrap"}
}
const _hoisted_374 = ["disabled"]
const _hoisted_375 = { class: "dash-modal-footer" }
const _hoisted_376 = ["disabled"]
const _hoisted_377 = { class: "border-style" }
const _hoisted_378 = {
  class: "dash-modal",
  style: {"max-width":"420px"}
}
const _hoisted_379 = {
  class: "dash-modal-body",
  style: {"padding":"1.75rem"}
}
const _hoisted_380 = { style: {"color":"#fff","margin":"0 0 1.5rem","font-size":"0.95rem"} }
const _hoisted_381 = { class: "d-flex gap-2 justify-content-end" }
const _hoisted_382 = { class: "border-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AnalyticsPanel = _resolveComponent("AnalyticsPanel")!
  const _component_SalesGuide = _resolveComponent("SalesGuide")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminLayout, null, {
      default: _withCtx(() => [
        (_ctx.activeTab === 'overview')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[128] || (_cache[128] = _createElementVNode("h2", { class: "dash-heading" }, "Dashboard Overview", -1)),
              (_ctx.statsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading stats..."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[114] || (_cache[114] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(201,14,14,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-users",
                            style: {"color":"#c90e0e"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.stats.total_users), 1),
                          _cache[113] || (_cache[113] = _createElementVNode("div", { class: "dash-stat-label" }, "Total Users", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[116] || (_cache[116] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(25,135,84,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-circle-check",
                            style: {"color":"#4ade80"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.stats.active_subs), 1),
                          _cache[115] || (_cache[115] = _createElementVNode("div", { class: "dash-stat-label" }, "Active Subscriptions", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[118] || (_cache[118] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(251,191,36,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-clock",
                            style: {"color":"#fbbf24"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.stats.pending_lines), 1),
                          _cache[117] || (_cache[117] = _createElementVNode("div", { class: "dash-stat-label" }, "Pending Lines", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[120] || (_cache[120] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(96,165,250,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-coin",
                            style: {"color":"#60a5fa"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_11, "$" + _toDisplayString(_ctx.money(_ctx.stats.total_revenue)), 1),
                          _cache[119] || (_cache[119] = _createElementVNode("div", { class: "dash-stat-label" }, "Total Revenue", -1))
                        ])
                      ]),
                      (_ctx.panelCredits)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _cache[122] || (_cache[122] = _createElementVNode("div", {
                              class: "dash-stat-icon",
                              style: {"background":"rgba(168,85,247,0.15)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ti ti-server",
                                style: {"color":"#a855f7"}
                              })
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.panelCredits.credits), 1),
                              _cache[121] || (_cache[121] = _createElementVNode("div", { class: "dash-stat-label" }, "Panel Credits", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[123] || (_cache[123] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, "Recent Users", -1)),
                            _createElementVNode("button", {
                              class: "dash-link-btn",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'users'))
                            }, "View All")
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("table", _hoisted_19, [
                              _cache[125] || (_cache[125] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "Name"),
                                  _createElementVNode("th", null, "Email"),
                                  _createElementVNode("th", null, "Status"),
                                  _createElementVNode("th", null, "Joined")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.recent_users, (u) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: u.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(u.name?.[0]?.toUpperCase()), 1),
                                        _createTextVNode(" " + _toDisplayString(u.name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(u.email), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["dash-badge", u.status === 'active' ? 'badge-green' : u.status === 'none' ? 'badge-gray' : 'badge-orange'])
                                      }, _toDisplayString(u.status), 3)
                                    ]),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(u.joined), 1)
                                  ]))
                                }), 128)),
                                (!_ctx.stats.recent_users?.length)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _cache[124] || (_cache[124] = [
                                      _createElementVNode("td", {
                                        colspan: "4",
                                        class: "text-center text-silver py-3"
                                      }, "No users yet", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _cache[126] || (_cache[126] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, "Pending Lines", -1)),
                            (_ctx.stats.pending_lines > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.stats.pending_lines), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.stats.pending_lines_list?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[127] || (_cache[127] = [
                                _createElementVNode("i", {
                                  class: "ti ti-circle-check",
                                  style: {"font-size":"2rem","color":"#4ade80","display":"block","margin-bottom":"0.5rem"}
                                }, null, -1),
                                _createElementVNode("p", {
                                  class: "text-silver mb-0",
                                  style: {"font-size":"0.9rem"}
                                }, "All lines assigned", -1)
                              ])))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.pending_lines_list, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: "dash-pending-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.name?.[0]?.toUpperCase()), 1),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(item.name), 1),
                                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.email), 1)
                                    ]),
                                    _createElementVNode("button", {
                                      class: "dash-action-btn",
                                      onClick: ($event: any) => (_ctx.openAssignModal(item))
                                    }, "Assign", 8, _hoisted_35)
                                  ]))
                                }), 128))
                              ]))
                        ])
                      ])
                    ])
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'users')
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[131] || (_cache[131] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "Users", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSearch) = $event)),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loadUsers && _ctx.loadUsers(...args)), ["enter"])),
                    type: "text",
                    class: "dash-input dash-search",
                    placeholder: "Search by name or email..."
                  }, null, 544), [
                    [_vModelText, _ctx.userSearch]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadUsers && _ctx.loadUsers(...args)))
                  }, _cache[129] || (_cache[129] = [
                    _createElementVNode("span", { class: "border-style" }, "Search", -1)
                  ])),
                  _createElementVNode("button", {
                    class: "btn btn-sm",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openBillModal()))
                  }, _cache[130] || (_cache[130] = [
                    _createElementVNode("span", { class: "border-style" }, [
                      _createElementVNode("i", { class: "ti ti-credit-card" }),
                      _createTextVNode(" Bill Client")
                    ], -1)
                  ]))
                ])
              ]),
              (_ctx.usersLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Loading users..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("table", _hoisted_42, [
                        _cache[135] || (_cache[135] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "User"),
                            _createElementVNode("th", null, "Email"),
                            _createElementVNode("th", null, "Phone"),
                            _createElementVNode("th", null, "Subscription"),
                            _createElementVNode("th", null, "Line"),
                            _createElementVNode("th", null, "Joined"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (u) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: u.id
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, _toDisplayString(u.name?.[0]?.toUpperCase()), 1),
                                  _createTextVNode(" " + _toDisplayString(u.name), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(u.email), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(u.phone || '—'), 1),
                              _createElementVNode("td", null, [
                                (u.subscriptions?.length)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["dash-badge", u.subscriptions[0].status === 'active' ? 'badge-green' : 'badge-orange'])
                                    }, _toDisplayString(u.subscriptions[0].package?.name), 3))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_47, "None"))
                              ]),
                              _createElementVNode("td", null, [
                                (u.iptv_lines?.length)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["dash-badge", u.iptv_lines[0].status === 'assigned' ? 'badge-green' : 'badge-orange'])
                                    }, _toDisplayString(u.iptv_lines[0].status), 3))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_48, "None"))
                              ]),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.formatDate(u.created_at)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    style: {"border-color":"#4ade80","color":"#4ade80"},
                                    onClick: ($event: any) => (_ctx.openBillModal(u))
                                  }, _cache[132] || (_cache[132] = [
                                    _createElementVNode("i", { class: "ti ti-credit-card" }, null, -1),
                                    _createTextVNode(" Bill ")
                                  ]), 8, _hoisted_51),
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    onClick: ($event: any) => (_ctx.openAssignModal({ user_id: u.id, name: u.name, email: u.email }))
                                  }, "Assign Line", 8, _hoisted_52),
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    style: {"border-color":"#60a5fa","color":"#60a5fa"},
                                    onClick: ($event: any) => (_ctx.openEmailModal(u))
                                  }, _cache[133] || (_cache[133] = [
                                    _createElementVNode("i", { class: "ti ti-mail" }, null, -1),
                                    _createTextVNode(" Email ")
                                  ]), 8, _hoisted_53)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.users.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_54, _cache[134] || (_cache[134] = [
                                _createElementVNode("td", {
                                  colspan: "7",
                                  class: "text-center text-silver py-3"
                                }, "No users found", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", _hoisted_56, "Page " + _toDisplayString(_ctx.usersMeta.current_page) + " of " + _toDisplayString(_ctx.usersMeta.last_page), 1),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.usersMeta.current_page <= 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadUsers(_ctx.usersMeta.current_page - 1)))
                        }, "Prev", 8, _hoisted_58),
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.usersMeta.current_page >= _ctx.usersMeta.last_page,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadUsers(_ctx.usersMeta.current_page + 1)))
                        }, "Next", 8, _hoisted_59)
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'emails')
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _cache[137] || (_cache[137] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "Email Centre", -1)),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openCompose()))
                }, _cache[136] || (_cache[136] = [
                  _createElementVNode("span", { class: "border-style" }, [
                    _createElementVNode("i", { class: "ti ti-plus" }),
                    _createTextVNode(" Compose")
                  ], -1)
                ]))
              ]),
              (_ctx.compose.open)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _cache[138] || (_cache[138] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, [
                        _createElementVNode("i", {
                          class: "ti ti-send",
                          style: {"color":"#60a5fa","margin-right":"0.4rem"}
                        }),
                        _createTextVNode("New Email")
                      ], -1)),
                      _createElementVNode("button", {
                        class: "dash-link-btn",
                        style: {"color":"#888"},
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.compose.open = false))
                      }, "✕ Close")
                    ]),
                    (_ctx.compose.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.compose.error), 1))
                      : _createCommentVNode("", true),
                    (_ctx.compose.success)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.compose.success), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_66, [
                      _cache[140] || (_cache[140] = _createElementVNode("label", { class: "dash-field-label" }, "To — type name, email, or select a user", -1)),
                      _createElementVNode("div", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.compose.userQuery) = $event)),
                          type: "text",
                          class: "dash-input",
                          placeholder: "e.g. john@example.com  or  John Doe",
                          style: _normalizeStyle(_ctx.compose.to_email ? 'border-color:#4ade80' : ''),
                          onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onUserQuery && _ctx.onUserQuery(...args))),
                          onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.compose.userResults = []), ["esc"])),
                          autocomplete: "off"
                        }, null, 36), [
                          [_vModelText, _ctx.compose.userQuery]
                        ]),
                        (_ctx.compose.to_email)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "compose-clear-btn",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearUser && _ctx.clearUser(...args))),
                              title: "Clear recipient"
                            }, "✕"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.compose.to_email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _cache[139] || (_cache[139] = _createElementVNode("i", {
                              class: "ti ti-circle-check",
                              style: {"color":"#4ade80"}
                            }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.compose.to_name ? _ctx.compose.to_name + ' — ' : '') + _toDisplayString(_ctx.compose.to_email), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.compose.userResults.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compose.userResults, (u) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: u.id,
                                class: "compose-dropdown-item",
                                onMousedown: _withModifiers(($event: any) => (_ctx.selectUser(u)), ["prevent"])
                              }, [
                                _createElementVNode("div", _hoisted_71, _toDisplayString(u.name?.[0]?.toUpperCase()), 1),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, _toDisplayString(u.name), 1),
                                  _createElementVNode("div", _hoisted_74, _toDisplayString(u.email) + _toDisplayString(u.phone ? '  ·  ' + u.phone : ''), 1)
                                ])
                              ], 40, _hoisted_70))
                            }), 128)),
                            (_ctx.compose.userSearching)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, "Searching..."))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _cache[141] || (_cache[141] = _createElementVNode("label", { class: "dash-field-label" }, "Subject", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.compose.subject) = $event)),
                        type: "text",
                        class: "dash-input",
                        placeholder: "e.g. Your GoPlayTV subscription is active"
                      }, null, 512), [
                        [_vModelText, _ctx.compose.subject]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _cache[142] || (_cache[142] = _createElementVNode("label", { class: "dash-field-label" }, "Message", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.compose.body) = $event)),
                        class: "dash-input",
                        rows: "8",
                        style: {"height":"auto","resize":"vertical","font-family":"inherit"},
                        placeholder: "Write your message here..."
                      }, null, 512), [
                        [_vModelText, _ctx.compose.body]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("button", {
                        class: "btn",
                        disabled: _ctx.compose.sending,
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitCompose && _ctx.submitCompose(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_80, [
                          _cache[143] || (_cache[143] = _createElementVNode("i", { class: "ti ti-send" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.compose.sending ? 'Sending...' : 'Send Email'), 1)
                        ])
                      ], 8, _hoisted_79),
                      _createElementVNode("button", {
                        class: "dash-action-btn",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.compose.open = false))
                      }, "Cancel")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.emailLogSearch) = $event)),
                    onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.loadEmails()), ["enter"])),
                    type: "text",
                    class: "dash-input dash-search",
                    placeholder: "Search by email, name, or subject..."
                  }, null, 544), [
                    [_vModelText, _ctx.emailLogSearch]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.loadEmails()))
                  }, _cache[144] || (_cache[144] = [
                    _createElementVNode("span", { class: "border-style" }, "Search", -1)
                  ]))
                ])
              ]),
              (_ctx.emailsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Loading emails..."))
                : (!_ctx.emailLog.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, _cache[145] || (_cache[145] = [
                      _createElementVNode("i", {
                        class: "ti ti-mail-off",
                        style: {"font-size":"2.5rem","color":"#555","display":"block","margin-bottom":"0.75rem"}
                      }, null, -1),
                      _createElementVNode("p", { class: "text-silver mb-0" }, "No emails sent yet. Hit Compose to send your first.", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("table", _hoisted_87, [
                          _cache[147] || (_cache[147] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "To"),
                              _createElementVNode("th", null, "Subject"),
                              _createElementVNode("th", null, "Status"),
                              _createElementVNode("th", null, "Sent"),
                              _createElementVNode("th", null, "Actions")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailLog, (em) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: em.id
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, _toDisplayString((em.to_name || em.to_email)?.[0]?.toUpperCase()), 1),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_90, _toDisplayString(em.to_name || '—'), 1),
                                      _createElementVNode("div", _hoisted_91, _toDisplayString(em.to_email), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_92, _toDisplayString(em.subject), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["dash-badge", em.status === 'sent' ? 'badge-green' : 'badge-red'])
                                  }, _toDisplayString(em.status), 3)
                                ]),
                                _createElementVNode("td", _hoisted_93, _toDisplayString(_ctx.formatDate(em.created_at)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    style: {"border-color":"#60a5fa","color":"#60a5fa"},
                                    onClick: ($event: any) => (_ctx.openCompose({ email: em.to_email, name: em.to_name, user_id: em.user_id }))
                                  }, _cache[146] || (_cache[146] = [
                                    _createElementVNode("i", { class: "ti ti-send" }, null, -1),
                                    _createTextVNode(" Reply ")
                                  ]), 8, _hoisted_94)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("span", _hoisted_96, "Page " + _toDisplayString(_ctx.emailLogMeta.current_page) + " of " + _toDisplayString(_ctx.emailLogMeta.last_page), 1),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("button", {
                            class: "dash-action-btn",
                            disabled: _ctx.emailLogMeta.current_page <= 1,
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loadEmails(_ctx.emailLogMeta.current_page - 1)))
                          }, "Prev", 8, _hoisted_98),
                          _createElementVNode("button", {
                            class: "dash-action-btn",
                            disabled: _ctx.emailLogMeta.current_page >= _ctx.emailLogMeta.last_page,
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.loadEmails(_ctx.emailLogMeta.current_page + 1)))
                          }, "Next", 8, _hoisted_99)
                        ])
                      ])
                    ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'payments')
          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
              _cache[160] || (_cache[160] = _createElementVNode("h2", { class: "dash-heading" }, "Payments", -1)),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _cache[149] || (_cache[149] = _createElementVNode("div", {
                    class: "dash-stat-icon",
                    style: {"background":"rgba(96,165,250,0.15)"}
                  }, [
                    _createElementVNode("i", {
                      class: "ti ti-coin",
                      style: {"color":"#60a5fa"}
                    })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_103, "$" + _toDisplayString(_ctx.money(_ctx.paymentStats.total_revenue)), 1),
                    _cache[148] || (_cache[148] = _createElementVNode("div", { class: "dash-stat-label" }, "Total Revenue", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _cache[151] || (_cache[151] = _createElementVNode("div", {
                    class: "dash-stat-icon",
                    style: {"background":"rgba(25,135,84,0.15)"}
                  }, [
                    _createElementVNode("i", {
                      class: "ti ti-circle-check",
                      style: {"color":"#4ade80"}
                    })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.paymentStats.completed), 1),
                    _cache[150] || (_cache[150] = _createElementVNode("div", { class: "dash-stat-label" }, "Completed", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _cache[153] || (_cache[153] = _createElementVNode("div", {
                    class: "dash-stat-icon",
                    style: {"background":"rgba(251,191,36,0.15)"}
                  }, [
                    _createElementVNode("i", {
                      class: "ti ti-clock",
                      style: {"color":"#fbbf24"}
                    })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.paymentStats.pending), 1),
                    _cache[152] || (_cache[152] = _createElementVNode("div", { class: "dash-stat-label" }, "Pending", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _cache[155] || (_cache[155] = _createElementVNode("div", {
                    class: "dash-stat-icon",
                    style: {"background":"rgba(201,14,14,0.15)"}
                  }, [
                    _createElementVNode("i", {
                      class: "ti ti-x",
                      style: {"color":"#f87171"}
                    })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.paymentStats.failed), 1),
                    _cache[154] || (_cache[154] = _createElementVNode("div", { class: "dash-stat-label" }, "Failed / Cancelled", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.paymentStatusFilter === '' }]),
                    onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.paymentStatusFilter = ''; _ctx.loadPayments()})
                  }, "All", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.paymentStatusFilter === 'completed' }]),
                    onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.paymentStatusFilter = 'completed'; _ctx.loadPayments()})
                  }, "Completed", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.paymentStatusFilter === 'pending' }]),
                    onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.paymentStatusFilter = 'pending'; _ctx.loadPayments()})
                  }, "Pending", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.paymentStatusFilter === 'failed' }]),
                    onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.paymentStatusFilter = 'failed'; _ctx.loadPayments()})
                  }, "Failed", 2)
                ])
              ]),
              (_ctx.paymentsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, "Loading payments..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("table", _hoisted_115, [
                        _cache[159] || (_cache[159] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "User"),
                            _createElementVNode("th", null, "Package"),
                            _createElementVNode("th", null, "Amount"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Invoice"),
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.id
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("div", _hoisted_117, _toDisplayString(p.user?.name?.[0]?.toUpperCase()), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, _toDisplayString(p.user?.name || '—'), 1),
                                    _createElementVNode("div", _hoisted_118, _toDisplayString(p.user?.email), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_119, [
                                _createTextVNode(_toDisplayString(p.package?.name || '—'), 1),
                                _cache[156] || (_cache[156] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("span", _hoisted_120, _toDisplayString(p.package?.duration_days ? p.package.duration_days + 'd' : ''), 1)
                              ]),
                              _createElementVNode("td", _hoisted_121, "$" + _toDisplayString(p.amount), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["dash-badge", {
                        'badge-green':  p.status === 'completed',
                        'badge-orange': p.status === 'pending',
                        'badge-red':    p.status === 'failed' || p.status === 'cancelled',
                      }])
                                }, _toDisplayString(p.status), 3)
                              ]),
                              _createElementVNode("td", _hoisted_122, _toDisplayString(p.invoice_id || '—'), 1),
                              _createElementVNode("td", _hoisted_123, _toDisplayString(_ctx.formatDate(p.created_at)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_124, [
                                  (p.checkout_url && p.status === 'pending')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "dash-action-btn",
                                        onClick: ($event: any) => (_ctx.openInvoiceDialog(p.checkout_url))
                                      }, _cache[157] || (_cache[157] = [
                                        _createElementVNode("i", { class: "ti ti-external-link" }, null, -1),
                                        _createTextVNode(" Invoice ")
                                      ]), 8, _hoisted_125))
                                    : _createCommentVNode("", true),
                                  (p.status === 'pending')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "dash-action-btn",
                                        style: {"border-color":"#4ade80","color":"#4ade80"},
                                        disabled: _ctx.markingPaid === p.id,
                                        onClick: ($event: any) => (_ctx.markAsPaid(p.id))
                                      }, _toDisplayString(_ctx.markingPaid === p.id ? '...' : '✓ Paid'), 9, _hoisted_126))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.payments.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_127, _cache[158] || (_cache[158] = [
                                _createElementVNode("td", {
                                  colspan: "7",
                                  class: "text-center text-silver py-3"
                                }, "No payments yet", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("span", _hoisted_129, "Page " + _toDisplayString(_ctx.paymentsMeta.current_page) + " of " + _toDisplayString(_ctx.paymentsMeta.last_page), 1),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.paymentsMeta.current_page <= 1,
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.loadPayments(_ctx.paymentsMeta.current_page - 1)))
                        }, "Prev", 8, _hoisted_131),
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.paymentsMeta.current_page >= _ctx.paymentsMeta.last_page,
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.loadPayments(_ctx.paymentsMeta.current_page + 1)))
                        }, "Next", 8, _hoisted_132)
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'packages')
          ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _cache[162] || (_cache[162] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "Packages", -1)),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.openPackageModal()))
                }, _cache[161] || (_cache[161] = [
                  _createElementVNode("span", { class: "border-style" }, "+ Add Package", -1)
                ]))
              ]),
              (_ctx.pkgsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_135, "Loading packages..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("table", _hoisted_138, [
                        _cache[165] || (_cache[165] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Image"),
                            _createElementVNode("th", null, "Name"),
                            _createElementVNode("th", null, "Price"),
                            _createElementVNode("th", null, "Duration"),
                            _createElementVNode("th", null, "Panel"),
                            _createElementVNode("th", null, "Features"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.id
                            }, [
                              _createElementVNode("td", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  (p.image_url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: p.image_url,
                                        alt: p.name,
                                        class: "pkg-thumb"
                                      }, null, 8, _hoisted_141))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_142, _cache[163] || (_cache[163] = [
                                        _createElementVNode("i", { class: "ti ti-photo" }, null, -1)
                                      ])))
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_143, _toDisplayString(p.name), 1),
                              _createElementVNode("td", _hoisted_144, "$" + _toDisplayString(p.price), 1),
                              _createElementVNode("td", _hoisted_145, _toDisplayString(p.duration_days) + " days", 1),
                              _createElementVNode("td", null, [
                                (p.panel_package_id)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "dash-badge badge-green",
                                      title: 'Panel package #' + p.panel_package_id
                                    }, " #" + _toDisplayString(p.panel_package_id), 9, _hoisted_146))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_147, "manual"))
                              ]),
                              _createElementVNode("td", _hoisted_148, [
                                (Array.isArray(p.features))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_149, _toDisplayString(p.features.join(', ')), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_150, "—"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_151, [
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    onClick: ($event: any) => (_ctx.openPackageModal(p))
                                  }, "Edit", 8, _hoisted_152),
                                  _createElementVNode("button", {
                                    class: "dash-action-btn dash-action-danger",
                                    onClick: ($event: any) => (_ctx.deletePackage(p.id))
                                  }, "Delete", 8, _hoisted_153)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.packages.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_154, _cache[164] || (_cache[164] = [
                                _createElementVNode("td", {
                                  colspan: "7",
                                  class: "text-center text-silver py-3"
                                }, "No packages yet", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'panel')
          ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                _cache[167] || (_cache[167] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "IPTV Panel", -1)),
                _createElementVNode("button", {
                  class: "dash-action-btn",
                  onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.reloadPanelTab && _ctx.reloadPanelTab(...args)))
                }, _cache[166] || (_cache[166] = [
                  _createElementVNode("i", { class: "ti ti-refresh" }, null, -1),
                  _createTextVNode(" Reload ")
                ]))
              ]),
              (!_ctx.panelCredits)
                ? (_openBlock(), _createElementBlock("div", _hoisted_157, _cache[168] || (_cache[168] = [
                    _createElementVNode("div", { class: "d-flex align-items-center gap-3" }, [
                      _createElementVNode("i", {
                        class: "ti ti-plug-x",
                        style: {"font-size":"1.8rem","color":"#fbbf24"}
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", { style: {"color":"#fff","font-weight":"700"} }, "Panel API not connected"),
                        _createElementVNode("p", {
                          class: "text-silver mb-0",
                          style: {"font-size":"0.85rem"}
                        }, [
                          _createTextVNode(" Set "),
                          _createElementVNode("code", null, "PANEL_API_KEY"),
                          _createTextVNode(" in the backend "),
                          _createElementVNode("code", null, ".env"),
                          _createTextVNode(" and make sure this server's IP is whitelisted on the panel. Until then, lines must be assigned manually. ")
                        ])
                      ])
                    ], -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_158, [
                    _createElementVNode("div", _hoisted_159, [
                      _cache[170] || (_cache[170] = _createElementVNode("div", {
                        class: "dash-stat-icon",
                        style: {"background":"rgba(168,85,247,0.15)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ti ti-coin",
                          style: {"color":"#a855f7"}
                        })
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.panelCredits.credits), 1),
                        _cache[169] || (_cache[169] = _createElementVNode("div", { class: "dash-stat-label" }, "Credits Remaining", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_161, [
                      _cache[172] || (_cache[172] = _createElementVNode("div", {
                        class: "dash-stat-icon",
                        style: {"background":"rgba(96,165,250,0.15)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ti ti-user",
                          style: {"color":"#60a5fa"}
                        })
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.panelCredits.username), 1),
                        _cache[171] || (_cache[171] = _createElementVNode("div", { class: "dash-stat-label" }, "Reseller Account", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_163, [
                      _cache[174] || (_cache[174] = _createElementVNode("div", {
                        class: "dash-stat-icon",
                        style: {"background":"rgba(74,222,128,0.15)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ti ti-world",
                          style: {"color":"#4ade80"}
                        })
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.panelCredits.reseller_dns || '—'), 1),
                        _cache[173] || (_cache[173] = _createElementVNode("div", { class: "dash-stat-label" }, "Reseller DNS", -1))
                      ])
                    ])
                  ])),
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("div", _hoisted_166, [
                  _cache[175] || (_cache[175] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, "Customer Lines", -1)),
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.panelLineFilter === '' }]),
                      onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.panelLineFilter = ''; _ctx.loadPanelLines()})
                    }, "All", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.panelLineFilter === 'active' }]),
                      onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.panelLineFilter = 'active'; _ctx.loadPanelLines()})
                    }, "Active", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["dash-action-btn", { 'active-filter': _ctx.panelLineFilter === 'pending_assignment' }]),
                      onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.panelLineFilter = 'pending_assignment'; _ctx.loadPanelLines()})
                    }, "Pending", 2)
                  ])
                ]),
                (_ctx.panelLinesLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, "Loading lines..."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      _createElementVNode("table", _hoisted_170, [
                        _cache[177] || (_cache[177] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "User"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Type"),
                            _createElementVNode("th", null, "Identifier"),
                            _createElementVNode("th", null, "Expires"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelLines, (l) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: l.id
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_171, [
                                  _createElementVNode("div", _hoisted_172, _toDisplayString(l.user?.name?.[0]?.toUpperCase()), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_173, _toDisplayString(l.user?.name || '—'), 1),
                                    _createElementVNode("div", _hoisted_174, _toDisplayString(l.user?.email), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["dash-badge", l.status === 'active' ? 'badge-green' : 'badge-orange'])
                                }, _toDisplayString(l.status === 'pending_assignment' ? 'pending' : l.status), 3)
                              ]),
                              _createElementVNode("td", null, [
                                (l.panel_type)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_175, _toDisplayString(l.panel_type), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_176, "manual"))
                              ]),
                              _createElementVNode("td", _hoisted_177, _toDisplayString(l.username || l.mac_address || '—'), 1),
                              _createElementVNode("td", _hoisted_178, _toDisplayString(l.expires_at ? _ctx.formatDate(l.expires_at) : '—'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "dash-action-btn",
                                  onClick: ($event: any) => (_ctx.openAssignModal({ user_id: l.user_id, name: l.user?.name, mac_address: l.mac_address }))
                                }, " Manage ", 8, _hoisted_179)
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.panelLines.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_180, _cache[176] || (_cache[176] = [
                                _createElementVNode("td", {
                                  colspan: "6",
                                  class: "text-center text-silver py-3"
                                }, "No lines yet", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])),
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("span", _hoisted_182, "Page " + _toDisplayString(_ctx.panelLinesMeta.current_page) + " of " + _toDisplayString(_ctx.panelLinesMeta.last_page), 1),
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("button", {
                      class: "dash-action-btn",
                      disabled: _ctx.panelLinesMeta.current_page <= 1,
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.loadPanelLines(_ctx.panelLinesMeta.current_page - 1)))
                    }, "Prev", 8, _hoisted_184),
                    _createElementVNode("button", {
                      class: "dash-action-btn",
                      disabled: _ctx.panelLinesMeta.current_page >= _ctx.panelLinesMeta.last_page,
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.loadPanelLines(_ctx.panelLinesMeta.current_page + 1)))
                    }, "Next", 8, _hoisted_185)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_186, [
                _createElementVNode("div", _hoisted_187, [
                  _cache[178] || (_cache[178] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, "Panel Packages & Mapping", -1)),
                  _createElementVNode("button", {
                    class: "dash-link-btn",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.activeTab = 'packages'))
                  }, "Edit Packages")
                ]),
                _cache[181] || (_cache[181] = _createElementVNode("p", {
                  class: "text-silver",
                  style: {"font-size":"0.85rem","margin-top":"-0.5rem"}
                }, " Map each GoPlayTV package to a panel package (edit the package and pick from the dropdown) so paid customers get provisioned automatically. ", -1)),
                (!_ctx.panelPackages.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_188, _cache[179] || (_cache[179] = [
                      _createElementVNode("i", { class: "ti ti-plug-x" }, null, -1),
                      _createTextVNode(" Panel packages unavailable — connect the panel API first. ")
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_189, [
                      _createElementVNode("table", _hoisted_190, [
                        _cache[180] || (_cache[180] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Panel ID"),
                            _createElementVNode("th", null, "Panel Package"),
                            _createElementVNode("th", null, "Cost"),
                            _createElementVNode("th", null, "Duration"),
                            _createElementVNode("th", null, "Connections"),
                            _createElementVNode("th", null, "Mapped Local Package")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelPackages, (pp) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: pp.id
                            }, [
                              _createElementVNode("td", _hoisted_191, "#" + _toDisplayString(pp.id), 1),
                              _createElementVNode("td", _hoisted_192, _toDisplayString(pp.name), 1),
                              _createElementVNode("td", _hoisted_193, _toDisplayString(pp.credits) + " credits", 1),
                              _createElementVNode("td", _hoisted_194, _toDisplayString(pp.duration) + " " + _toDisplayString(pp.duration_in), 1),
                              _createElementVNode("td", _hoisted_195, _toDisplayString(pp.connections), 1),
                              _createElementVNode("td", null, [
                                (_ctx.mappedLocalPackage(pp.id))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_196, _toDisplayString(_ctx.mappedLocalPackage(pp.id)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_197, "—"))
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'channels')
          ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
              _createElementVNode("div", _hoisted_199, [
                _cache[183] || (_cache[183] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "Channels", -1)),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.openChannelModal()))
                }, _cache[182] || (_cache[182] = [
                  _createElementVNode("span", { class: "border-style" }, "+ Add Channel", -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_200, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.channelSearch) = $event)),
                  onKeyup: _cache[38] || (_cache[38] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loadChannels && _ctx.loadChannels(...args)), ["enter"])),
                  type: "text",
                  class: "dash-input dash-search",
                  placeholder: "Search channels..."
                }, null, 544), [
                  [_vModelText, _ctx.channelSearch]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-sm",
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.loadChannels && _ctx.loadChannels(...args)))
                }, _cache[184] || (_cache[184] = [
                  _createElementVNode("span", { class: "border-style" }, "Search", -1)
                ]))
              ]),
              (_ctx.channelsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_201, "Loading channels..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_202, [
                    _createElementVNode("div", _hoisted_203, [
                      _createElementVNode("table", _hoisted_204, [
                        _cache[187] || (_cache[187] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Logo"),
                            _createElementVNode("th", null, "Name"),
                            _createElementVNode("th", null, "Category"),
                            _createElementVNode("th", null, "Country"),
                            _createElementVNode("th", null, "Active"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (ch) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: ch.id
                            }, [
                              _createElementVNode("td", _hoisted_205, [
                                _createElementVNode("div", _hoisted_206, [
                                  (ch.logo_url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: ch.logo_url,
                                        alt: ch.name,
                                        class: "pkg-thumb",
                                        style: {"object-fit":"contain","background":"#0a0102"}
                                      }, null, 8, _hoisted_207))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_208, _cache[185] || (_cache[185] = [
                                        _createElementVNode("i", { class: "ti ti-tv" }, null, -1)
                                      ])))
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_209, _toDisplayString(ch.name), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_210, _toDisplayString(ch.category), 1)
                              ]),
                              _createElementVNode("td", _hoisted_211, _toDisplayString(ch.country || '—'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["dash-badge", ch.is_active ? 'badge-green' : 'badge-gray'])
                                }, _toDisplayString(ch.is_active ? 'Active' : 'Hidden'), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_212, [
                                  _createElementVNode("button", {
                                    class: "dash-action-btn",
                                    onClick: ($event: any) => (_ctx.openChannelModal(ch))
                                  }, "Edit", 8, _hoisted_213),
                                  _createElementVNode("button", {
                                    class: "dash-action-btn dash-action-danger",
                                    onClick: ($event: any) => (_ctx.deleteChannel(ch.id))
                                  }, "Delete", 8, _hoisted_214)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.channels.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_215, _cache[186] || (_cache[186] = [
                                _createElementVNode("td", {
                                  colspan: "6",
                                  class: "text-center text-silver py-3"
                                }, "No channels yet. Add your first channel above.", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("span", _hoisted_217, "Page " + _toDisplayString(_ctx.channelsMeta.current_page) + " of " + _toDisplayString(_ctx.channelsMeta.last_page), 1),
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.channelsMeta.current_page <= 1,
                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.loadChannels(_ctx.channelsMeta.current_page - 1)))
                        }, "Prev", 8, _hoisted_219),
                        _createElementVNode("button", {
                          class: "dash-action-btn",
                          disabled: _ctx.channelsMeta.current_page >= _ctx.channelsMeta.last_page,
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.loadChannels(_ctx.channelsMeta.current_page + 1)))
                        }, "Next", 8, _hoisted_220)
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'content')
          ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
              _cache[190] || (_cache[190] = _createElementVNode("h2", { class: "dash-heading" }, "Website CMS", -1)),
              _cache[191] || (_cache[191] = _createElementVNode("p", {
                class: "text-silver mb-4",
                style: {"margin-top":"-1rem","font-size":"0.95rem"}
              }, " Edit every section of your landing page, navbar, and footer here. ", -1)),
              (_ctx.cmsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_222, "Loading sections..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_223, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmsSections, (block) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: block.section,
                        class: "col-md-6 col-lg-4"
                      }, [
                        _createElementVNode("div", _hoisted_224, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_225, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.cmsIcon(block.section)),
                                style: {"color":"#c90e0e","font-size":"1.1rem"}
                              }, null, 2),
                              _createElementVNode("h5", _hoisted_226, _toDisplayString(_ctx.CMS_LABELS[block.section] || block.section.replace(/_/g,' ')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_227, " Updated " + _toDisplayString(_ctx.formatDate(block.updated_at)), 1)
                          ]),
                          _createVNode(_component_RouterLink, {
                            to: '/admin/content/' + block.section,
                            class: "btn mt-3 d-block text-center"
                          }, {
                            default: _withCtx(() => _cache[188] || (_cache[188] = [
                              _createElementVNode("span", { class: "border-style" }, "Edit Content", -1)
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128)),
                    (!_ctx.cmsSections.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_228, _cache[189] || (_cache[189] = [
                          _createElementVNode("div", { class: "dash-card text-center py-4" }, [
                            _createElementVNode("p", { class: "text-silver mb-0" }, "No content sections found. Run the database seeder first.")
                          ], -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
              _cache[201] || (_cache[201] = _createElementVNode("h2", { class: "dash-heading" }, "Settings", -1)),
              (_ctx.settingsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_230, "Loading settings..."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.settingsMsg)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_231, _toDisplayString(_ctx.settingsMsg), 1))
                      : _createCommentVNode("", true),
                    (_ctx.settingsError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_232, _toDisplayString(_ctx.settingsError), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_233, [
                      _cache[194] || (_cache[194] = _createElementVNode("div", { class: "dash-card-header" }, [
                        _createElementVNode("h5", { class: "dash-card-title mb-0" }, [
                          _createElementVNode("i", {
                            class: "ti ti-mail",
                            style: {"color":"#60a5fa","margin-right":"0.5rem"}
                          }),
                          _createTextVNode("Email / SMTP")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_234, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settingsByGroup('email'), (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s.key,
                            class: "col-md-6"
                          }, [
                            _createElementVNode("label", _hoisted_235, [
                              _createTextVNode(_toDisplayString(s.label) + " ", 1),
                              (s.is_secret)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_236, "secret"))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.settingsDraft[s.key]) = $event),
                              type: s.is_secret ? 'password' : 'text',
                              class: "dash-input",
                              placeholder: s.is_secret ? 'Enter to change' : s.label,
                              autocomplete: "off"
                            }, null, 8, _hoisted_237), [
                              [_vModelDynamic, _ctx.settingsDraft[s.key]]
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_238, [
                        _cache[193] || (_cache[193] = _createElementVNode("div", { class: "st-test-label" }, [
                          _createElementVNode("i", {
                            class: "ti ti-send",
                            style: {"color":"#60a5fa"}
                          }),
                          _createTextVNode(" Send a test email to verify SMTP ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_239, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.testMailTo) = $event)),
                            type: "email",
                            class: "dash-input",
                            placeholder: "your@email.com",
                            style: {"flex":"1","min-width":"200px"}
                          }, null, 512), [
                            [_vModelText, _ctx.testMailTo]
                          ]),
                          _createElementVNode("button", {
                            class: "dash-action-btn",
                            style: {"border-color":"#60a5fa","color":"#60a5fa","white-space":"nowrap"},
                            disabled: _ctx.testMailSending || !_ctx.testMailTo,
                            onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.sendTestMail && _ctx.sendTestMail(...args)))
                          }, [
                            _cache[192] || (_cache[192] = _createElementVNode("i", { class: "ti ti-send" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.testMailSending ? 'Sending...' : 'Send Test'), 1)
                          ], 8, _hoisted_240)
                        ]),
                        (_ctx.testMailMsg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_241, _toDisplayString(_ctx.testMailMsg), 1))
                          : _createCommentVNode("", true),
                        (_ctx.testMailError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_242, _toDisplayString(_ctx.testMailError), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_243, [
                      _cache[196] || (_cache[196] = _createElementVNode("div", { class: "dash-card-header" }, [
                        _createElementVNode("h5", { class: "dash-card-title mb-0" }, [
                          _createElementVNode("i", {
                            class: "ti ti-credit-card",
                            style: {"color":"#4ade80","margin-right":"0.5rem"}
                          }),
                          _createTextVNode("Payments")
                        ])
                      ], -1)),
                      _cache[197] || (_cache[197] = _createElementVNode("p", {
                        class: "text-silver mb-3",
                        style: {"font-size":"0.88rem"}
                      }, [
                        _createTextVNode(" Choose which gateway handles the "),
                        _createElementVNode("strong", null, "Pay by Card"),
                        _createTextVNode(" button. Provider credentials live in the backend "),
                        _createElementVNode("code", null, ".env"),
                        _createTextVNode("; a gateway shown as "),
                        _createElementVNode("em", null, "not configured"),
                        _createTextVNode(" can't be selected until its keys are set. ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_244, [
                        _createElementVNode("div", _hoisted_245, [
                          _cache[195] || (_cache[195] = _createElementVNode("label", { class: "dash-field-label" }, "Active Card Gateway", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.settingsDraft['card_gateway']) = $event)),
                            class: "dash-input"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateways, (g) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: g.key,
                                value: g.key,
                                disabled: !g.configured
                              }, _toDisplayString(g.label) + _toDisplayString(g.configured ? '' : ' — not configured'), 9, _hoisted_246))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.settingsDraft['card_gateway']]
                          ])
                        ])
                      ]),
                      (_ctx.gateways.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateways, (g) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: g.key,
                                class: _normalizeClass(["dash-badge", g.configured ? 'badge-green' : 'badge-gray'])
                              }, _toDisplayString(g.label) + ": " + _toDisplayString(g.configured ? 'configured' : 'missing keys'), 3))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_248, [
                      _cache[198] || (_cache[198] = _createElementVNode("div", { class: "dash-card-header" }, [
                        _createElementVNode("h5", { class: "dash-card-title mb-0" }, [
                          _createElementVNode("i", {
                            class: "ti ti-settings",
                            style: {"color":"#c90e0e","margin-right":"0.5rem"}
                          }),
                          _createTextVNode("General")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_249, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settingsByGroup('general'), (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s.key,
                            class: "col-md-6"
                          }, [
                            _createElementVNode("label", _hoisted_250, _toDisplayString(s.label), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.settingsDraft[s.key]) = $event),
                              type: "text",
                              class: "dash-input",
                              placeholder: s.label
                            }, null, 8, _hoisted_251), [
                              [_vModelText, _ctx.settingsDraft[s.key]]
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_252, [
                      _createElementVNode("button", {
                        class: "btn",
                        disabled: _ctx.settingsSaving,
                        onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_254, [
                          _cache[199] || (_cache[199] = _createElementVNode("i", { class: "ti ti-device-floppy" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.settingsSaving ? 'Saving...' : 'Save Settings'), 1)
                        ])
                      ], 8, _hoisted_253),
                      _createElementVNode("button", {
                        class: "dash-action-btn",
                        onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.loadSettings && _ctx.loadSettings(...args)))
                      }, _cache[200] || (_cache[200] = [
                        _createElementVNode("i", { class: "ti ti-refresh" }, null, -1),
                        _createTextVNode(" Reset ")
                      ]))
                    ])
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'media')
          ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
              _createElementVNode("div", _hoisted_256, [
                _cache[202] || (_cache[202] = _createElementVNode("h2", { class: "dash-heading mb-0" }, "Media Library", -1)),
                _createElementVNode("label", _hoisted_257, [
                  _createElementVNode("span", _hoisted_258, _toDisplayString(_ctx.mediaUploading ? 'Uploading...' : '+ Upload Image'), 1),
                  _createElementVNode("input", {
                    type: "file",
                    class: "d-none",
                    accept: "image/*",
                    disabled: _ctx.mediaUploading,
                    onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.uploadMedia && _ctx.uploadMedia(...args)))
                  }, null, 40, _hoisted_259)
                ])
              ]),
              (_ctx.mediaLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_260, "Loading media..."))
                : (!_ctx.mediaList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_261, _cache[203] || (_cache[203] = [
                      _createElementVNode("i", {
                        class: "ti ti-photo-off",
                        style: {"font-size":"2.5rem","color":"#555","display":"block","margin-bottom":"0.75rem"}
                      }, null, -1),
                      _createElementVNode("p", { class: "text-silver mb-0" }, "No images uploaded yet. Upload your first image above.", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_262, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "media-item"
                        }, [
                          _createElementVNode("div", _hoisted_263, [
                            _createElementVNode("img", {
                              src: item.url,
                              alt: item.original_name
                            }, null, 8, _hoisted_264)
                          ]),
                          _createElementVNode("div", _hoisted_265, [
                            _createElementVNode("div", {
                              class: "media-name",
                              title: item.original_name
                            }, _toDisplayString(item.original_name), 9, _hoisted_266),
                            _createElementVNode("div", _hoisted_267, [
                              _createElementVNode("button", {
                                class: "dash-action-btn",
                                onClick: ($event: any) => (_ctx.copyMediaUrl(item.url, item.id))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.mediaCopied === item.id ? 'ti ti-check' : 'ti ti-copy')
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.mediaCopied === item.id ? 'Copied!' : 'Copy URL'), 1)
                              ], 8, _hoisted_268),
                              _createElementVNode("button", {
                                class: "dash-action-btn dash-action-danger",
                                onClick: ($event: any) => (_ctx.deleteMedia(item.id))
                              }, _cache[204] || (_cache[204] = [
                                _createElementVNode("i", { class: "ti ti-trash" }, null, -1)
                              ]), 8, _hoisted_269)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'analytics')
          ? (_openBlock(), _createBlock(_component_AnalyticsPanel, { key: 10 }))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'guide')
          ? (_openBlock(), _createBlock(_component_SalesGuide, { key: 11 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.assignModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dash-modal-overlay",
          onClick: _cache[60] || (_cache[60] = _withModifiers(($event: any) => (_ctx.assignModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_270, [
            _createElementVNode("div", _hoisted_271, [
              _createElementVNode("h5", null, "IPTV Line — " + _toDisplayString(_ctx.assignModal.name), 1),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.assignModal.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_272, [
              (_ctx.assignModal.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_273, _toDisplayString(_ctx.assignModal.error), 1))
                : _createCommentVNode("", true),
              (_ctx.assignModal.mac_address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                    _cache[206] || (_cache[206] = _createElementVNode("i", { class: "ti ti-device-desktop" }, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[205] || (_cache[205] = _createElementVNode("div", { style: {"color":"#a0a0a0","font-size":"0.75rem","margin-bottom":"2px"} }, "Client MAC Address", -1)),
                      _createElementVNode("code", _hoisted_275, _toDisplayString(_ctx.assignModal.mac_address), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_276, _cache[207] || (_cache[207] = [
                    _createElementVNode("i", { class: "ti ti-device-desktop" }, null, -1),
                    _createElementVNode("span", { style: {"color":"#888","font-size":"0.85rem"} }, "No MAC address submitted yet", -1)
                  ]))),
              (_ctx.assignModal.panel_type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                    _cache[209] || (_cache[209] = _createElementVNode("i", { class: "ti ti-server" }, null, -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_278, [
                        _cache[208] || (_cache[208] = _createTextVNode(" Provisioned on panel as ")),
                        _createElementVNode("strong", _hoisted_279, _toDisplayString(_ctx.assignModal.panel_type), 1),
                        (_ctx.assignModal.expires_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_280, " · expires " + _toDisplayString(_ctx.formatDate(_ctx.assignModal.expires_at)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.assignModal.portal_url)
                        ? (_openBlock(), _createElementBlock("code", _hoisted_281, _toDisplayString(_ctx.assignModal.portal_url), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_282, [
                _createElementVNode("div", _hoisted_283, [
                  _cache[210] || (_cache[210] = _createElementVNode("label", { class: "dash-field-label" }, "Server URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.assignModal.form.server_url) = $event)),
                    type: "text",
                    class: "dash-input",
                    placeholder: "http://yourserver.com:8080"
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.server_url]
                  ])
                ]),
                _createElementVNode("div", _hoisted_284, [
                  _cache[211] || (_cache[211] = _createElementVNode("label", { class: "dash-field-label" }, "M3U URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.assignModal.form.m3u_url) = $event)),
                    type: "text",
                    class: "dash-input",
                    placeholder: "http://server:port/get.php?username=...&password=...&type=m3u"
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.m3u_url]
                  ])
                ]),
                _createElementVNode("div", _hoisted_285, [
                  _cache[212] || (_cache[212] = _createElementVNode("label", { class: "dash-field-label" }, "EPG URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.assignModal.form.epg_url) = $event)),
                    type: "text",
                    class: "dash-input",
                    placeholder: "http://server:port/xmltv.php?username=...&password=..."
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.epg_url]
                  ])
                ]),
                _createElementVNode("div", _hoisted_286, [
                  _cache[213] || (_cache[213] = _createElementVNode("label", { class: "dash-field-label" }, "Username", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.assignModal.form.username) = $event)),
                    type: "text",
                    class: "dash-input"
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.username]
                  ])
                ]),
                _createElementVNode("div", _hoisted_287, [
                  _cache[214] || (_cache[214] = _createElementVNode("label", { class: "dash-field-label" }, "Password", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.assignModal.form.password) = $event)),
                    type: "text",
                    class: "dash-input"
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.password]
                  ])
                ]),
                _createElementVNode("div", _hoisted_288, [
                  _cache[215] || (_cache[215] = _createElementVNode("label", { class: "dash-field-label" }, "Notes for client (optional)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.assignModal.form.notes) = $event)),
                    class: "dash-input",
                    rows: "2",
                    style: {"height":"auto","resize":"vertical"},
                    placeholder: "e.g. Use iboPlayer, enter server URL above"
                  }, null, 512), [
                    [_vModelText, _ctx.assignModal.form.notes]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_289, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.assignModal.saving,
                onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.submitAssign && _ctx.submitAssign(...args)))
              }, [
                _createElementVNode("span", _hoisted_291, _toDisplayString(_ctx.assignModal.saving ? 'Saving...' : 'Save & Activate'), 1)
              ], 8, _hoisted_290),
              (_ctx.assignModal.line_id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "dash-action-btn",
                    style: {"border-color":"#a855f7","color":"#a855f7"},
                    disabled: !!_ctx.panelBusy,
                    onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.provisionFromPanel && _ctx.provisionFromPanel(...args)))
                  }, [
                    _cache[216] || (_cache[216] = _createElementVNode("i", { class: "ti ti-server" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.panelBusy === 'provision' ? 'Provisioning...' : (_ctx.assignModal.panel_type ? 'Extend via Panel' : 'Auto-Provision')), 1)
                  ], 8, _hoisted_292))
                : _createCommentVNode("", true),
              (_ctx.assignModal.line_id && (_ctx.assignModal.panel_type || _ctx.assignModal.form.username || _ctx.assignModal.mac_address))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "dash-action-btn",
                    disabled: !!_ctx.panelBusy,
                    onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.refreshFromPanel && _ctx.refreshFromPanel(...args)))
                  }, [
                    _cache[217] || (_cache[217] = _createElementVNode("i", { class: "ti ti-refresh" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.panelBusy === 'refresh' ? 'Refreshing...' : 'Refresh Status'), 1)
                  ], 8, _hoisted_293))
                : _createCommentVNode("", true),
              (_ctx.assignModal.line_id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "dash-action-btn",
                    style: {"border-color":"#60a5fa","color":"#60a5fa"},
                    disabled: _ctx.emailingCreds,
                    onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.emailCredentials && _ctx.emailCredentials(...args)))
                  }, [
                    _cache[218] || (_cache[218] = _createElementVNode("i", { class: "ti ti-mail" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.emailingCreds ? 'Sending...' : 'Email Credentials'), 1)
                  ], 8, _hoisted_294))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "dash-action-btn",
                onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.assignModal.open = false))
              }, "Cancel"),
              (_ctx.emailCredsMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_295, _toDisplayString(_ctx.emailCredsMsg), 1))
                : _createCommentVNode("", true),
              (_ctx.panelMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_296, _toDisplayString(_ctx.panelMsg), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.invoiceDialog.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dash-modal-overlay",
          onClick: _cache[63] || (_cache[63] = _withModifiers(($event: any) => (_ctx.invoiceDialog.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_297, [
            _createElementVNode("div", _hoisted_298, [
              _cache[219] || (_cache[219] = _createElementVNode("h5", null, "Payment Invoice", -1)),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.invoiceDialog.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_299, [
              _cache[221] || (_cache[221] = _createElementVNode("p", {
                class: "text-silver mb-3",
                style: {"font-size":"0.9rem"}
              }, "Payment pages cannot be embedded. Open in a new tab:", -1)),
              _createElementVNode("a", {
                href: _ctx.invoiceDialog.url,
                target: "_blank",
                rel: "noopener",
                class: "btn",
                onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.invoiceDialog.open = false))
              }, _cache[220] || (_cache[220] = [
                _createElementVNode("span", { class: "border-style" }, [
                  _createElementVNode("i", { class: "ti ti-external-link" }),
                  _createTextVNode(" Open Invoice Page")
                ], -1)
              ]), 8, _hoisted_300)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pkgModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "dash-modal-overlay",
          onClick: _cache[78] || (_cache[78] = _withModifiers(($event: any) => (_ctx.pkgModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_301, [
            _createElementVNode("div", _hoisted_302, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.pkgModal.editing ? 'Edit Package' : 'New Package'), 1),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.pkgModal.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_303, [
              (_ctx.pkgModal.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_304, _toDisplayString(_ctx.pkgModal.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_305, [
                _createElementVNode("div", _hoisted_306, [
                  _cache[222] || (_cache[222] = _createElementVNode("label", { class: "dash-field-label" }, "Package Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.pkgModal.form.name) = $event)),
                    type: "text",
                    class: "dash-input"
                  }, null, 512), [
                    [_vModelText, _ctx.pkgModal.form.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_307, [
                  _cache[223] || (_cache[223] = _createElementVNode("label", { class: "dash-field-label" }, "Price ($)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.pkgModal.form.price) = $event)),
                    type: "number",
                    step: "0.01",
                    class: "dash-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.pkgModal.form.price,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_308, [
                  _cache[224] || (_cache[224] = _createElementVNode("label", { class: "dash-field-label" }, "Days", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.pkgModal.form.duration_days) = $event)),
                    type: "number",
                    class: "dash-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.pkgModal.form.duration_days,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_309, [
                  _cache[226] || (_cache[226] = _createElementVNode("label", { class: "dash-field-label" }, "Package Image", -1)),
                  _createElementVNode("div", _hoisted_310, [
                    (_ctx.pkgModal.form.image_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_311, [
                          _createElementVNode("img", {
                            src: _ctx.pkgModal.form.image_url,
                            alt: "Package image"
                          }, null, 8, _hoisted_312),
                          _createElementVNode("button", {
                            class: "pkg-image-remove",
                            onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.pkgModal.form.image_url = '')),
                            title: "Remove image"
                          }, "✕")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_313, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.pkgModal.form.image_url) = $event)),
                        type: "text",
                        class: "dash-input",
                        placeholder: "Paste image URL or upload below...",
                        style: {"flex":"1"}
                      }, null, 512), [
                        [_vModelText, _ctx.pkgModal.form.image_url]
                      ]),
                      _createElementVNode("label", _hoisted_314, [
                        _cache[225] || (_cache[225] = _createElementVNode("i", { class: "ti ti-upload" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.pkgModal.imageUploading ? 'Uploading...' : 'Upload') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          class: "d-none",
                          disabled: _ctx.pkgModal.imageUploading,
                          onChange: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.uploadPkgImage && _ctx.uploadPkgImage(...args)))
                        }, null, 40, _hoisted_315)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_316, [
                  _cache[228] || (_cache[228] = _createElementVNode("label", { class: "dash-field-label" }, "Panel Package (auto-provisioning)", -1)),
                  (_ctx.panelPackages.length)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.pkgModal.form.panel_package_id) = $event)),
                        class: "dash-input"
                      }, [
                        _cache[227] || (_cache[227] = _createElementVNode("option", { value: null }, "— Not mapped (assign lines manually) —", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelPackages, (pp) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: pp.id,
                            value: Number(pp.id)
                          }, " #" + _toDisplayString(pp.id) + " — " + _toDisplayString(pp.name) + " (" + _toDisplayString(pp.credits) + " cr / " + _toDisplayString(pp.duration) + " " + _toDisplayString(pp.duration_in) + ") ", 9, _hoisted_317))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, _ctx.pkgModal.form.panel_package_id]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.pkgModal.form.panel_package_id) = $event)),
                        type: "number",
                        min: "1",
                        class: "dash-input",
                        placeholder: "Panel package ID (panel offline)"
                      }, null, 512)), [
                        [
                          _vModelText,
                          _ctx.pkgModal.form.panel_package_id,
                          void 0,
                          { number: true }
                        ]
                      ])
                ]),
                _createElementVNode("div", _hoisted_318, [
                  _cache[230] || (_cache[230] = _createElementVNode("label", { class: "dash-field-label" }, "Panel Template (optional)", -1)),
                  (_ctx.panelTemplates.length)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.pkgModal.form.panel_template_id) = $event)),
                        class: "dash-input"
                      }, [
                        _cache[229] || (_cache[229] = _createElementVNode("option", { value: null }, "— Default —", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelTemplates, (t) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: t.id,
                            value: Number(t.id)
                          }, " #" + _toDisplayString(t.id) + " — " + _toDisplayString(t.title), 9, _hoisted_319))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, _ctx.pkgModal.form.panel_template_id]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.pkgModal.form.panel_template_id) = $event)),
                        type: "number",
                        min: "1",
                        class: "dash-input",
                        placeholder: "Panel template ID (optional)"
                      }, null, 512)), [
                        [
                          _vModelText,
                          _ctx.pkgModal.form.panel_template_id,
                          void 0,
                          { number: true }
                        ]
                      ])
                ]),
                _createElementVNode("div", _hoisted_320, [
                  _cache[231] || (_cache[231] = _createElementVNode("label", { class: "dash-field-label" }, "Features (one per line)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.pkgModal.featuresText) = $event)),
                    class: "dash-input",
                    rows: "4",
                    style: {"height":"auto","resize":"vertical"},
                    placeholder: "HD Channels\nSports Package\n24/7 Support"
                  }, null, 512), [
                    [_vModelText, _ctx.pkgModal.featuresText]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_321, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.pkgModal.saving,
                onClick: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.submitPackage && _ctx.submitPackage(...args)))
              }, [
                _createElementVNode("span", _hoisted_323, _toDisplayString(_ctx.pkgModal.saving ? 'Saving...' : (_ctx.pkgModal.editing ? 'Update' : 'Create')), 1)
              ], 8, _hoisted_322),
              _createElementVNode("button", {
                class: "dash-action-btn",
                onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.pkgModal.open = false))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.billModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "dash-modal-overlay",
          onClick: _cache[91] || (_cache[91] = _withModifiers(($event: any) => (_ctx.billModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_324, [
            _createElementVNode("div", _hoisted_325, [
              _cache[232] || (_cache[232] = _createElementVNode("h5", null, [
                _createElementVNode("i", {
                  class: "ti ti-credit-card",
                  style: {"color":"#4ade80","margin-right":"0.4rem"}
                }),
                _createTextVNode("Bill Client")
              ], -1)),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.billModal.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_326, [
              (_ctx.billModal.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_327, _toDisplayString(_ctx.billModal.error), 1))
                : _createCommentVNode("", true),
              (_ctx.billModal.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_328, _toDisplayString(_ctx.billModal.success), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_329, [
                _cache[234] || (_cache[234] = _createElementVNode("label", { class: "dash-field-label" }, "Client", -1)),
                _createElementVNode("div", _hoisted_330, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.billModal.userQuery) = $event)),
                    type: "text",
                    class: "dash-input",
                    placeholder: "Search by name or email...",
                    style: _normalizeStyle(_ctx.billModal.user_id ? 'border-color:#4ade80' : ''),
                    onInput: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.onBillUserQuery && _ctx.onBillUserQuery(...args))),
                    onKeydown: _cache[82] || (_cache[82] = _withKeys(($event: any) => (_ctx.billModal.userResults = []), ["esc"])),
                    autocomplete: "off"
                  }, null, 36), [
                    [_vModelText, _ctx.billModal.userQuery]
                  ]),
                  (_ctx.billModal.user_id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "compose-clear-btn",
                        onClick: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.clearBillUser && _ctx.clearBillUser(...args))),
                        title: "Clear"
                      }, "✕"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.billModal.user_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_331, [
                      _cache[233] || (_cache[233] = _createElementVNode("i", {
                        class: "ti ti-circle-check",
                        style: {"color":"#4ade80"}
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.billModal.userName) + " — " + _toDisplayString(_ctx.billModal.userEmail), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.billModal.userResults.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_332, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billModal.userResults, (u) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: u.id,
                          class: "compose-dropdown-item",
                          onMousedown: _withModifiers(($event: any) => (_ctx.selectBillUser(u)), ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_334, _toDisplayString(u.name?.[0]?.toUpperCase()), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_335, _toDisplayString(u.name), 1),
                            _createElementVNode("div", _hoisted_336, _toDisplayString(u.email), 1)
                          ])
                        ], 40, _hoisted_333))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_337, [
                _cache[236] || (_cache[236] = _createElementVNode("label", { class: "dash-field-label" }, "Package", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.billModal.package_id) = $event)),
                  class: "dash-input",
                  onChange: _cache[85] || (_cache[85] = 
//@ts-ignore
(...args) => (_ctx.onBillPackageChange && _ctx.onBillPackageChange(...args)))
                }, [
                  _cache[235] || (_cache[235] = _createElementVNode("option", { value: "" }, "— Select a package —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: p.id,
                      value: p.id
                    }, _toDisplayString(p.name) + " — $" + _toDisplayString(p.price) + " / " + _toDisplayString(p.duration_days) + " days ", 9, _hoisted_338))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.billModal.package_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_339, [
                _cache[237] || (_cache[237] = _createElementVNode("label", { class: "dash-field-label" }, "Amount Paid (USD)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.billModal.amount) = $event)),
                  type: "number",
                  step: "0.01",
                  min: "0",
                  class: "dash-input",
                  placeholder: "0.00"
                }, null, 512), [
                  [_vModelText, _ctx.billModal.amount]
                ])
              ]),
              _createElementVNode("div", _hoisted_340, [
                _cache[238] || (_cache[238] = _createElementVNode("label", { class: "dash-field-label" }, "Notes (optional)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.billModal.notes) = $event)),
                  class: "dash-input",
                  rows: "2",
                  style: {"height":"auto","resize":"vertical"},
                  placeholder: "e.g. Paid via M-Pesa, Ref #12345"
                }, null, 512), [
                  [_vModelText, _ctx.billModal.notes]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_341, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.billModal.saving || _ctx.billModal.sendingLink,
                onClick: _cache[88] || (_cache[88] = 
//@ts-ignore
(...args) => (_ctx.submitBill && _ctx.submitBill(...args)))
              }, [
                _createElementVNode("span", _hoisted_343, [
                  _cache[239] || (_cache[239] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.billModal.saving ? 'Activating...' : 'Activate Subscription'), 1)
                ])
              ], 8, _hoisted_342),
              _createElementVNode("button", {
                class: "dash-action-btn",
                disabled: _ctx.billModal.saving || _ctx.billModal.sendingLink,
                onClick: _cache[89] || (_cache[89] = 
//@ts-ignore
(...args) => (_ctx.sendPaymentLink && _ctx.sendPaymentLink(...args))),
                title: "Create a Lipad card/M-Pesa payment link and email it to the client"
              }, [
                _cache[240] || (_cache[240] = _createElementVNode("i", { class: "ti ti-link" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.billModal.sendingLink ? 'Sending link...' : 'Email Payment Link'), 1)
              ], 8, _hoisted_344),
              _createElementVNode("button", {
                class: "dash-action-btn",
                onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.billModal.open = false))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.emailModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "dash-modal-overlay",
          onClick: _cache[97] || (_cache[97] = _withModifiers(($event: any) => (_ctx.emailModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_345, [
            _createElementVNode("div", _hoisted_346, [
              _cache[241] || (_cache[241] = _createElementVNode("h5", null, [
                _createElementVNode("i", {
                  class: "ti ti-mail",
                  style: {"color":"#60a5fa","margin-right":"0.4rem"}
                }),
                _createTextVNode("Email Client")
              ], -1)),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.emailModal.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_347, [
              (_ctx.emailModal.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_348, _toDisplayString(_ctx.emailModal.error), 1))
                : _createCommentVNode("", true),
              (_ctx.emailModal.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_349, _toDisplayString(_ctx.emailModal.success), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_350, [
                _cache[242] || (_cache[242] = _createElementVNode("label", { class: "dash-field-label" }, "To", -1)),
                _createElementVNode("input", {
                  value: _ctx.emailModal.to_name + ' <' + _ctx.emailModal.to_email + '>',
                  type: "text",
                  class: "dash-input",
                  readonly: "",
                  style: {"background":"#0a0102","color":"#888","cursor":"default"}
                }, null, 8, _hoisted_351)
              ]),
              _createElementVNode("div", _hoisted_352, [
                _cache[243] || (_cache[243] = _createElementVNode("label", { class: "dash-field-label" }, "Subject", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.emailModal.subject) = $event)),
                  type: "text",
                  class: "dash-input",
                  placeholder: "e.g. Your GoPlayTV subscription"
                }, null, 512), [
                  [_vModelText, _ctx.emailModal.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_353, [
                _cache[244] || (_cache[244] = _createElementVNode("label", { class: "dash-field-label" }, "Message", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.emailModal.body) = $event)),
                  class: "dash-input",
                  rows: "8",
                  style: {"height":"auto","resize":"vertical"},
                  placeholder: "Write your message here..."
                }, null, 512), [
                  [_vModelText, _ctx.emailModal.body]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_354, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.emailModal.sending,
                onClick: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
              }, [
                _createElementVNode("span", _hoisted_356, [
                  _cache[245] || (_cache[245] = _createElementVNode("i", { class: "ti ti-send" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.emailModal.sending ? 'Sending...' : 'Send Email'), 1)
                ])
              ], 8, _hoisted_355),
              _createElementVNode("button", {
                class: "dash-action-btn",
                onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.emailModal.open = false))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.chModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "dash-modal-overlay",
          onClick: _cache[109] || (_cache[109] = _withModifiers(($event: any) => (_ctx.chModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_357, [
            _createElementVNode("div", _hoisted_358, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.chModal.editing ? 'Edit Channel' : 'New Channel'), 1),
              _createElementVNode("button", {
                class: "dash-modal-close",
                onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.chModal.open = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_359, [
              (_ctx.chModal.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_360, _toDisplayString(_ctx.chModal.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_361, [
                _createElementVNode("div", _hoisted_362, [
                  _cache[246] || (_cache[246] = _createElementVNode("label", { class: "dash-field-label" }, "Channel Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.chModal.form.name) = $event)),
                    type: "text",
                    class: "dash-input"
                  }, null, 512), [
                    [_vModelText, _ctx.chModal.form.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_363, [
                  _cache[247] || (_cache[247] = _createElementVNode("label", { class: "dash-field-label" }, "Category", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.chModal.form.category) = $event)),
                    class: "dash-input"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelCategories, (cat) => {
                      return (_openBlock(), _createElementBlock("option", { key: cat }, _toDisplayString(cat), 1))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.chModal.form.category]
                  ])
                ]),
                _createElementVNode("div", _hoisted_364, [
                  _cache[248] || (_cache[248] = _createElementVNode("label", { class: "dash-field-label" }, "Country (optional)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.chModal.form.country) = $event)),
                    type: "text",
                    class: "dash-input",
                    placeholder: "e.g. USA, UK, Global"
                  }, null, 512), [
                    [_vModelText, _ctx.chModal.form.country]
                  ])
                ]),
                _createElementVNode("div", _hoisted_365, [
                  _cache[249] || (_cache[249] = _createElementVNode("label", { class: "dash-field-label" }, "Sort Order", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.chModal.form.sort_order) = $event)),
                    type: "number",
                    class: "dash-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.chModal.form.sort_order,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_366, [
                  _createElementVNode("label", _hoisted_367, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.chModal.form.is_active) = $event)),
                      type: "checkbox",
                      style: {"width":"auto"}
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.chModal.form.is_active]
                    ]),
                    _cache[250] || (_cache[250] = _createElementVNode("span", { style: {"font-size":"0.85rem"} }, "Active", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_368, [
                  _cache[252] || (_cache[252] = _createElementVNode("label", { class: "dash-field-label" }, "Channel Logo", -1)),
                  _createElementVNode("div", _hoisted_369, [
                    (_ctx.chModal.form.logo_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_370, [
                          _createElementVNode("img", {
                            src: _ctx.chModal.form.logo_url,
                            alt: "Channel logo",
                            style: {"object-fit":"contain","background":"#0a0102"}
                          }, null, 8, _hoisted_371),
                          _createElementVNode("button", {
                            class: "pkg-image-remove",
                            onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.chModal.form.logo_url = ''))
                          }, "✕")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_372, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.chModal.form.logo_url) = $event)),
                        type: "text",
                        class: "dash-input",
                        placeholder: "Paste logo URL or upload...",
                        style: {"flex":"1"}
                      }, null, 512), [
                        [_vModelText, _ctx.chModal.form.logo_url]
                      ]),
                      _createElementVNode("label", _hoisted_373, [
                        _cache[251] || (_cache[251] = _createElementVNode("i", { class: "ti ti-upload" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.chModal.uploading ? 'Uploading...' : 'Upload') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          class: "d-none",
                          disabled: _ctx.chModal.uploading,
                          onChange: _cache[106] || (_cache[106] = 
//@ts-ignore
(...args) => (_ctx.uploadChannelLogo && _ctx.uploadChannelLogo(...args)))
                        }, null, 40, _hoisted_374)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_375, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.chModal.saving,
                onClick: _cache[107] || (_cache[107] = 
//@ts-ignore
(...args) => (_ctx.submitChannel && _ctx.submitChannel(...args)))
              }, [
                _createElementVNode("span", _hoisted_377, _toDisplayString(_ctx.chModal.saving ? 'Saving...' : (_ctx.chModal.editing ? 'Update' : 'Create')), 1)
              ], 8, _hoisted_376),
              _createElementVNode("button", {
                class: "dash-action-btn",
                onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.chModal.open = false))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.confirmDialog.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "dash-modal-overlay",
          style: {"z-index":"1100"},
          onClick: _cache[112] || (_cache[112] = _withModifiers(($event: any) => (_ctx.resolveConfirm(false)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_378, [
            _createElementVNode("div", _hoisted_379, [
              _createElementVNode("p", _hoisted_380, _toDisplayString(_ctx.confirmDialog.message), 1),
              _createElementVNode("div", _hoisted_381, [
                (_ctx.confirmDialog.showCancel)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "dash-action-btn",
                      onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.resolveConfirm(false)))
                    }, "Cancel"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.resolveConfirm(true)))
                }, [
                  _createElementVNode("span", _hoisted_382, _toDisplayString(_ctx.confirmDialog.okText), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}